import React from 'react'



export default function Mobileapp() {
    return (
        <>
            <div className='py-20 relative'>
                <div className='max-w-7xl mx-auto px-4'>
                    <div className="bg-gray-100 rounded-3xl w-full px-10 mb-24 py-6">
                        <div className='flex items-center justify-between gap-10'>
                            <div className='max-w-[620px]'>
                                <h2 className='text-5xl mb-4' style={{ fontFamily: 'Philosopher, sans-serif' }}>Download Mahima app now</h2>
                                <p className='mb-8 text-gray-400'>Listen to Swaminarayan live katha, kirtan and dhun (tunes). Users can add the selected video in favourites and daily niyams and sabha attendance and more...</p>
                                <div className='flex items-center gap-3'>
                                    <div onClick={() => window.open('https://play.google.com/store/apps/details?id=com.swaminarayansurat.mahima&hl=en_IN', '_blank')}> <img src='./assets/play-store.png' alt='daily-darshan' /></div>
                                    <div onClick={() => window.open('https://apps.apple.com/us/app/mahima-smv/id6505094690 ', '_blank')}> <img src='./assets/app-store.png' alt='daily-darshan' /></div>
                                </div>
                            </div>
                            <div>
                                <img src='./assets/app-image.png' alt='daily-darshan' />
                            </div>
                        </div>
                    </div>
                    <div className='mb-20'>
                        <h2 className='text-5xl mb-10 text-center' style={{ fontFamily: 'Philosopher, sans-serif' }}>Covered on <span className='text-primary mb-9'>Mahima</span> APP</h2>
                        <div className='flex items-center justify-center gap-5'>
                            <div className='bg-gray-200 border-gray-300 border-2 rounded-xl p-6 max-w-48 w-full flex justify-center'>
                                <img src='./assets/mantra-lekhan.png' alt='daily-darshan' className='rounded-2xl overflow-hidden w-16' />
                            </div>
                            <div className='bg-gray-200 border-gray-300 border-2 rounded-xl p-6 max-w-48 w-full flex justify-center'>
                                <img src='./assets/six-dham.png' alt='daily-darshan' className='rounded-2xl overflow-hidden w-16' />
                            </div>
                            <div className='bg-gray-200 border-gray-300 border-2 rounded-xl p-6 max-w-48 w-full flex justify-center'>
                                <img src='./assets/event.png' alt='daily-darshan' className='rounded-2xl overflow-hidden w-16' />
                            </div>
                            <div className='bg-gray-200 border-gray-300 border-2 rounded-xl p-6 max-w-48 w-full flex justify-center'>
                                <img src='./assets/mala.png' alt='daily-darshan' className='rounded-2xl overflow-hidden w-16' />
                            </div>
                            <div className='bg-gray-200 border-gray-300 border-2 rounded-xl p-6 max-w-48 w-full flex justify-center'>
                                <img src='./assets/katha.png' alt='daily-darshan' className='rounded-2xl overflow-hidden w-16' />
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </>
    )
}
